import { usePage } from "@inertiajs/react";
import { CurrentPlayer, User } from "@/types";

interface AuthData {
  user: User | null;
  player: CurrentPlayer | null;
  logged_in: boolean;
}

export function useAuth(): AuthData {
  const { props } = usePage<{ auth: AuthData }>();
  return props.auth;
}
